import { PiUserBold, PiCalendarBlankBold } from "react-icons/pi";
import { useParams, Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Footer, MarkdownParser, Navbar } from "../components";
import { GenericMarkdownLoadingSkeleton } from "../components/LoadingSkeleton";
import ErrorPage from "./ErrorPage";
import { formatDate } from "../utils/helper";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const ArtikelTextPage = () => {
  const { slug } = useParams();

  const getArticle = async () => {
    return await customAxios.get(`articles/${slug}`);
  };

  const {
    data: articlesData,
    isFetching,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["data"],
    queryFn: () => getArticle(),
    placeholderData: keepPreviousData, // don't have 0 rows flash while changing pages/loading next page
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const Crumbs = (
    <div
      className={`${styles.textLRegularM} w-full text-neutral-80 mb-2 overflow-auto`}
    >
      {/* Changed w-fit to w-max so it expands properly for scrolling */}
      <div className="flex items-center gap-2 w-max">
        <Link to="/" className="hover:underline whitespace-nowrap shrink-0">
          beranda
        </Link>

        <FaChevronRight className="w-2 shrink-0" />

        <Link
          to="/artikel"
          className="hover:underline whitespace-nowrap shrink-0"
        >
          artikel
        </Link>

        <FaChevronRight className="w-2 shrink-0" />

        {/* Removed line-clamp-1 so the full slug is visible via scrolling */}
        <p className="whitespace-nowrap shrink-0">{slug}</p>
      </div>
    </div>
  );

  const renderContent = () => {
    if (isLoading || isFetching) {
      return (
        <>
          <div className="w-full p-6 bg-gray-200 rounded animate-pulse"></div>
          <div className="flex items-center w-full gap-4 mt-3 mb-16">
            <div className="bg-gray-200 animate-pulse p-3 w-[200px]"></div>
            <div className="bg-gray-200 animate-pulse p-3 w-[200px]"></div>
          </div>
          <div
            className={`my-8 size-full aspect-video animate-pulse bg-gray-200`}
          ></div>
          <GenericMarkdownLoadingSkeleton />
        </>
      );
    }

    const { data } = articlesData.data;

    // TODO: EMPTY STATE
    if (!data) return null;

    const { title, description, created_at, thumbnail } = data;

    return (
      <div>
        <h1 className={`text-[36px] leading-11 text-neutral-100 font-bold`}>
          {title}
        </h1>

        <div className="flex items-center gap-4 mt-3 sm:gap-1 sm:flex-col sm:items-start">
          <div className="flex items-center gap-2">
            <PiUserBold className="fill-neutral-80" />
            <p className={`${styles.textLRegular} text-neutral-80 mx-2`}>
              Admin UNIVERAL
            </p>
          </div>
          <div className="flex items-center gap-2">
            <PiCalendarBlankBold className="fill-neutral-80" />
            <p className={`${styles.textLRegular} text-neutral-80 mx-2`}>
              {formatDate(created_at)}
            </p>
          </div>
        </div>

        <img
          className={`my-8 w-full h-full object-cover`}
          src={thumbnail}
          alt={title}
        />

        <MarkdownParser content={description} />
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div
        className={`${styles.paddingX} gap-4 flex flex-wrap justify-center py-20`}
      >
        <div className="max-w-[858px] w-full">
          {Crumbs}
          {renderContent()}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArtikelTextPage;
